const SEO_SCRIPT_FAQ = /<(?!\/?td|\/?tr|\/?caption|\/?thead|\/?th|\/?table)[^>]*>|[\r\n]+/g;

export const stringFormatterSeoScript = (text?: string) => text?.replace(SEO_SCRIPT_FAQ, '');

